define.alias("shared/components/shared/social/refresh-profile/facebook", "calendar/components/shared/social/refresh-profile/facebook");